var watchlistPositionList = {
	caption: "Lista di Posizioni Watchlist",
	name: "Nome",
	isin: "ISIN",
	lastPrice: "Ultimo prezzo",
	lastPriceDateTime: "Data/Ora",
	perf: "Perf.",
	perfRel: "Perf. %",
	volume: "Volume",
	tradingVolume: "Vol. trading",
	exchange: "Borsa",
	actions: "Azioni",
	noPositions: "Nessun risultato trovato"
};
var it = {
	watchlistPositionList: watchlistPositionList
};

export { it as default, watchlistPositionList };
